<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'ExchangeRateSourceSpecEditor',
    inheritAttrs: false,
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save', 'input']);

  const props = defineProps({
    value: {
      type: Object,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const emitChange = (...args) => {
    let value = item.value;
    if (_.isEmpty(value.source) || _.isEmpty(value.rate_source)) {
      value = null;
    }
    emit('input', value);
  };

  const item = ref(null);
  const sources = ref(null);
  const rateSources = ref(null);
  const ux = ref([]);

  const $data = computed(() => ({
    item: item.value,
    sources: sources.value,
    rateSources: rateSources.value,
    ux: ux.value,
  }));

  const $$load_item = async () => {
    return (
      props.value || {
        source: null,
        rate_source: null,
        invoice_description: null,
      }
    );
  };
  const $$load_sources = async () => {
    return $app.value.repo.get('list_exchange_rate_source');
  };
  const $$load_rateSources = async () => {
    return $app.value.repo.get('ui_metadata', {
      path: 'exchange_rate_rate_source_type_options',
    });
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      { name: 'item' },
      { name: 'sources' },
      { name: 'rateSources' },
      { name: 'ux' },
    ],
    loaders: {
      item: $$load_item,
      sources: $$load_sources,
      rateSources: $$load_rateSources,
    },
    ux: {},
    dataRefs: { item, sources, rateSources, ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.value,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('value');
    }
  );
  watch(
    () => props.readonly,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('readonly');
    }
  );

  const act_8320016629450276_script_q774zhfe9_value_callable = async (
    $event
  ) => {
    return emitChange();
  };
  const act_8320016629450276_script_q774zhfe9_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_8320016629450276_script_q774zhfe9_value_callable($event);
      },
    };
  };
  const act_1040167445267876_script_qa83das85_value_callable = async (
    $event
  ) => {
    return emitChange();
  };
  const act_1040167445267876_script_qa83das85_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_1040167445267876_script_qa83das85_value_callable($event);
      },
    };
  };
  const act_1548630417156826_script_alyn581ma_value_callable = async (
    $event
  ) => {
    return emitChange();
  };
  const act_1548630417156826_script_alyn581ma_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_1548630417156826_script_alyn581ma_value_callable($event);
      },
    };
  };

  const act_8320016629450276_script_q774zhfe9 = new actionTypes.ScriptAction({
    actionArgs: act_8320016629450276_script_q774zhfe9_getActionArgs,
    displayName: 'emitChange',
  });
  const inst_evh_8320016629450276_input_uwxqi4n58 =
    new actionTypes.EventHandlerImpl({
      action: act_8320016629450276_script_q774zhfe9,
      event: 'input',
      displayName: 'emitChange',
    });
  const inst_evh_8320016629450276_input = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_8320016629450276_input_uwxqi4n58],
    event: 'input',
  });
  const act_1040167445267876_script_qa83das85 = new actionTypes.ScriptAction({
    actionArgs: act_1040167445267876_script_qa83das85_getActionArgs,
    displayName: 'emitChange',
  });
  const inst_evh_1040167445267876_input_86hoqkdqq =
    new actionTypes.EventHandlerImpl({
      action: act_1040167445267876_script_qa83das85,
      event: 'input',
      displayName: 'emitChange',
    });
  const inst_evh_1040167445267876_input = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_1040167445267876_input_86hoqkdqq],
    event: 'input',
  });
  const act_1548630417156826_script_alyn581ma = new actionTypes.ScriptAction({
    actionArgs: act_1548630417156826_script_alyn581ma_getActionArgs,
    displayName: 'emitChange',
  });
  const inst_evh_1548630417156826_input_wmv40ihgu =
    new actionTypes.EventHandlerImpl({
      action: act_1548630417156826_script_alyn581ma,
      event: 'input',
      displayName: 'emitChange',
    });
  const inst_evh_1548630417156826_input = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_1548630417156826_input_wmv40ihgu],
    event: 'input',
  });

  const actions = {
    inst_evh_8320016629450276_input_uwxqi4n58,
    emitChange: inst_evh_8320016629450276_input_uwxqi4n58,
    inst_evh_8320016629450276_input,
    inst_evh_1040167445267876_input_86hoqkdqq,
    inst_evh_1040167445267876_input,
    inst_evh_1548630417156826_input_wmv40ihgu,
    inst_evh_1548630417156826_input,
  };

  const evh_8320016629450276_input_uwxqi4n58 = async (event, scope) => {
    return await actions.inst_evh_8320016629450276_input_uwxqi4n58.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8320016629450276_input = async (event, scope) => {
    return await actions.inst_evh_8320016629450276_input.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1040167445267876_input_86hoqkdqq = async (event, scope) => {
    return await actions.inst_evh_1040167445267876_input_86hoqkdqq.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1040167445267876_input = async (event, scope) => {
    return await actions.inst_evh_1040167445267876_input.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1548630417156826_input_wmv40ihgu = async (event, scope) => {
    return await actions.inst_evh_1548630417156826_input_wmv40ihgu.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1548630417156826_input = async (event, scope) => {
    return await actions.inst_evh_1548630417156826_input.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <div class="row g-2 align-items-stretch" v-if="loaded">
    <div class="col">
      <div class="input-group">
        <span class="input-group-text">
          <ItpIcon icon="ic:baseline-cable"> </ItpIcon>
        </span>
        <ItpSelect2
          name="source"
          v-model="item.source"
          :value="item.source"
          @input="
            !($event && typeof $event.stopPropagation === 'function') &&
              (item.source =
                $event && typeof $event === 'object' && 'data' in $event
                  ? $event.data
                  : $event);
            evh_8320016629450276_input($event, {});
          "
          bind-object
          :options="sources"
          valueField="value"
          textField="name"
          clearable
          :readonly="readonly"
        >
        </ItpSelect2>
      </div>
    </div>
    <div class="col">
      <ItpFormSelect2
        name="rate_source"
        v-model="item.rate_source"
        :value="item.rate_source"
        @input="
          !($event && typeof $event.stopPropagation === 'function') &&
            (item.rate_source =
              $event && typeof $event === 'object' && 'data' in $event
                ? $event.data
                : $event);
          evh_1040167445267876_input($event, {});
        "
        :options="rateSources"
        valueField="value"
        textField="name"
        clearable
        null-option
        :readonly="readonly"
      >
      </ItpFormSelect2>
    </div>
    <div class="col">
      <ItpFormInput
        name="invoice_description"
        v-model="item.invoice_description"
        :value="item.invoice_description"
        @input="
          !($event && typeof $event.stopPropagation === 'function') &&
            (item.invoice_description =
              $event && typeof $event === 'object' && 'data' in $event
                ? $event.data
                : $event);
          evh_1548630417156826_input($event, {});
        "
        :readonly="readonly"
        :placeholder="pgettext('ExchangeRateSourceSpec', 'Invoice description')"
      >
      </ItpFormInput>
    </div>
  </div>
</template>
